import axios from "axios";
import { Global } from "../../config/global";


export const endChat = async (chatData) => {
    try {
        let token = localStorage.getItem('token'); // Extraer el token del localStorage.
        let url = Global.url + `chat/end/${chatData.IdChat}`;

        let config = {
            method: 'post',
            url: url,
            headers: { // Definir el encabezado de la petición.
                Authorization: `Bearer ${token}`
            }
        };
        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
            })
            .catch((error) => {
                console.log(error);
            });


    } catch (error) {
        console.log("Error al finalizar la sesión:", error);
    }
}